<iframe [src]="safeResourceUrl" class="three-d-view" [style.visibility]="visibility" #iframe></iframe>
<div class="background"></div>
